module.exports = __webpack_public_path__ + "static/media/bet-blue-2.5147c938.png";